import {
  GET_STUDENTS,
  GET_STUDENTS_FAIL,
  GET_STUDENTS_SUCCESS,
  ADD_NEW_STUDENT,
  ADD_STUDENT_SUCCESS,
  ADD_STUDENT_FAIL,
  UPDATE_STUDENT,
  UPDATE_STUDENT_SUCCESS,
  UPDATE_STUDENT_FAIL,
  DELETE_STUDENT,
  DELETE_STUDENT_SUCCESS,
  DELETE_STUDENT_FAIL,

  GET_STUDENT_BY_UUID,
  GET_STUDENT_BY_UUID_FAIL,
  GET_STUDENT_BY_UUID_SUCCESS,
  
} from "./actionTypes";

/*
export const getStudents = () => ({
  type: GET_STUDENTS,
})
  */
export const getStudents = (filters) => ({
  type: GET_STUDENTS,
  payload: filters,  
});

export const getStudentsSuccess = students => ({
  type: GET_STUDENTS_SUCCESS,
  payload: students,
})

export const getStudentsFail = error => ({
  type: GET_STUDENTS_FAIL,
  payload: error,
})

export const addNewStudent = data => ({
  type: ADD_NEW_STUDENT,
  payload: data,
})

export const addStudentSuccess = student => ({
  type: ADD_STUDENT_SUCCESS,
  payload: student,
})

export const addStudentFail = error => ({
  type: ADD_STUDENT_FAIL,
  payload: error,
})

export const updateStudent = student => ({
  type: UPDATE_STUDENT,
  payload: student,
})

export const updateStudentSuccess = student => ({
  type: UPDATE_STUDENT_SUCCESS,
  payload: student,
})

export const updateStudentFail = error => ({
  type: UPDATE_STUDENT_FAIL,
  payload: error,
})

export const deleteStudent = data => ({
  type: DELETE_STUDENT,
  payload: data,
})

export const deleteStudentSuccess = data => ({
  type: DELETE_STUDENT_SUCCESS,
  payload: data,
})

export const deleteStudentFail = error => ({
  type: DELETE_STUDENT_FAIL,
  payload: error,
})

// GET STUDENT BY UID
export const getStudentByUuid = (uuid) => ({
  type: GET_STUDENT_BY_UUID,
  payload: uuid,
});

export const getStudentByUuidSuccess = (student) => ({
  type: GET_STUDENT_BY_UUID_SUCCESS,
  payload: student,
});

export const getStudentByUuidFail = (error) => ({
  type: GET_STUDENT_BY_UUID_FAIL,
  payload: error,
});
